export default "__VITE_ASSET__pB7LzZeZ__"